import { getToken } from '../utils/auth';
import { driApiDelay } from '../constants';

const request = (method, path, body, requestName) => {
  let url;
  if (requestName === 'approveDimensionList') {
    url = `${window.config.apiUrl}${path}`;
  } else {
    url = `${window.config.sapiUrl}${path}`;
  }

  const options = {
    method,
    headers: {
      authorization: `Bearer ${getToken()}`,
      'Content-Type': 'application/json',
      ...(window.appInsights?.context?.getSessionId() && {
        'correlation-id': window.appInsights.context?.getSessionId(),
      }),
    },
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  return fetch(new Request(url, options));
};

const lastRequestTime = {};
const validateRequestTime = requestName => {
  const previous = lastRequestTime[requestName];
  const now = Date.now();
  if (!previous || now > previous + driApiDelay) {
    lastRequestTime[requestName] = now;
    return;
  }

  const remaining = Math.round((driApiDelay - (now - previous)) / 1000);
  const error = `DRI [${requestName}] was run recently. Please wait ${remaining} seconds and try again.`;
  throw new Error(error);
};

const DriOperations = {
  getCacheKeys() {
    return request('GET', `/cache/keys`);
  },
  getCacheKeysForPrefix(prefix) {
    return request('GET', `/cache/keys?startsWith=${prefix}`);
  },
  getCacheEntryDetails(key) {
    return request('GET', `/cache/keys/${key}`);
  },
  deleteCacheEntry(key) {
    return request('DELETE', `/cache/keys/${key}`);
  },
  deleteCacheEntriesForPrefix(prefix) {
    return request('DELETE', `/cache/keys?startsWith=${prefix}`);
  },
  deleteAllCacheEntries() {
    return request('DELETE', `/cache/flushall`);
  },
  generateMultipleInvoices(params) {
    validateRequestTime('generateMultipleInvoices');
    return request('POST', '/invoices/multiple', params);
  },
  regenerateMultipleStatements(params) {
    validateRequestTime('regenerateStatement');
    if (!params.visibleToPartner) {
      return request('PATCH', '/statements/regenerate/multiple', params);
    }
    return request('POST', '/statements/generatePreviewStatement', params);
  },
  approveMultipleStatements(params) {
    validateRequestTime('approveMultipleStatements');
    return request('PATCH', '/statements/multiple', {
      ...params,
      status: 'Approved',
    });
  },
  approveMultipleDimensionLists(params) {
    validateRequestTime('approveDimensionList');
    return request('PATCH', `/dimensionlists/approve/multiple`, params, 'approveDimensionList');
  },
  sendEvents: async (silo, events) => {
    validateRequestTime('sendTlaEvents');
    let path;
    switch (silo) {
      case '1p-azure':
        path = '/send-events/1p-azure';
        break;
      case '3p-tla':
        path = '/send-events/3p-tla';
        break;
      default:
        path = '';
        break;
    }
    if (path === '') {
      throw new Error('Invalid silo');
    }
    return request('POST', path, events);
  },
};

export default DriOperations;
